import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_322966864 from "../../../../../packages/component/src/components/tree/demo/demo1.js?loadDemo";
import legacyImportDemo_2532537651 from "../../../../../packages/component/src/components/tree/demo/demo2.js?loadDemo";
import legacyImportDemo_3876465554 from "../../../../../packages/component/src/components/tree/demo/demo3.js?loadDemo";
import legacyImportDemo_3276001909 from "../../../../../packages/component/src/components/tree/demo/demo4.js?loadDemo";
import legacyImportDemo_4088479188 from "../../../../../packages/component/src/components/tree/demo/demo5.js?loadDemo";
import legacyImportDemo_2920421815 from "../../../../../packages/component/src/components/tree/demo/demo6.js?loadDemo";
import legacyImportDemo_2517812246 from "../../../../../packages/component/src/components/tree/demo/demo7.js?loadDemo";
import legacyImportDemo_653762809 from "../../../../../packages/component/src/components/tree/demo/demo8.js?loadDemo";
import legacyImportDemo_2801870936 from "../../../../../packages/component/src/components/tree/demo/demo9.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_322966864,
  legacyImportDemo_2532537651,
  legacyImportDemo_3876465554,
  legacyImportDemo_3276001909,
  legacyImportDemo_4088479188,
  legacyImportDemo_2920421815,
  legacyImportDemo_2517812246,
  legacyImportDemo_653762809,
  legacyImportDemo_2801870936,
  React
};